<template>
  <form @submit.prevent.stop="submit()" v-if="promoteur">
    <div class="columns is-multiline">
      <div class="column is-12 is-paddingless">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Nom</label>
              <div class="control">
                <v-input name="name" @input="val => promoteur.name = val" :model="promoteur.name" classes="input"
                        v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Nom"></v-input>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isSuperAdmin" class="columns">
          <div class="column is-4">
            <div class="field">
              <span class="label">Flux activé</span>
              <input id="flux_enabled" type="checkbox" name="flux_enabled"
                    class="switch is-success is-rounded is-medium"
                    v-model="promoteur.flux_enabled">
              <label for="flux_enabled"></label>
            </div>
          </div>
        </div>
        <div v-if="isSuperAdmin && promoteur.flux" class="columns is-multiline">
          <div class="column is-4">
            <div class="field">
              <label class="label">Connecteur</label>
              <div class="control">
                <v-input name="connector" @input="val => promoteur.flux.connector = val" :model="promoteur.flux.connector"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="Connecteur"></v-input>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Hôte</label>
              <div class="control">
                <v-input name="host" @input="val => promoteur.flux.host = val" :model="promoteur.flux.host"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="Host"></v-input>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">WebHook</label>
              <div class="control">
                <v-input name="webhook" @input="val => promoteur.flux.webhook = val" :model="promoteur.flux.webhook"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="WebHook"></v-input>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Clé API</label>
              <div class="control">
                <v-input name="api_key" @input="val => promoteur.flux.api_key = val" :model="promoteur.flux.api_key"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="API Key"></v-input>
              </div>
            </div>
          </div>
          <div class="column is-8">
            <div class="field">
              <label class="label">Heure de synchronisation</label>
              <div class="control">
                <v-input name="cronjob_time" @input="val => promoteur.flux.cronjob_time = val" :model="promoteur.flux.cronjob_time"
                         classes="input is-fullwidth" :errors-bag="errors" :placeholder="'1230 pour 12h30, 0800 pour 08H00'"
                         data-vv-value-path="val" data-vv-as="Crontab time"></v-input>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isSuperAdmin && promoteur.flux" class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Répertoire</label>
              <div class="control">
                <v-input name="dir" @input="val => promoteur.flux.dir = val" :model="promoteur.flux.dir" classes="input"
                        data-vv-value-path="val" data-vv-as="Directory" :errors-bag="errors"></v-input>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Nom du fichier</label>
              <div class="control">
                <v-input name="filename" @input="val => promoteur.flux.filename = val" :model="promoteur.flux.filename"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="Filename"></v-input>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isSuperAdmin && promoteur.flux" class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Utilisateur</label>
              <div class="control">
                <v-input name="user" @input="val => promoteur.flux.user = val" :model="promoteur.flux.user"
                        classes="input" :errors-bag="errors"
                        data-vv-value-path="val" data-vv-as="User"></v-input>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Mot de passe</label>
              <div class="control">
                <v-input name="pwd" @input="val => promoteur.flux.pwd = val" :model="promoteur.flux.pwd" classes="input"
                        data-vv-value-path="val" data-vv-as="Password" :errors-bag="errors"></v-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="hero is-light">
        <div class="hero-body">
          <div class="container">
            <div class="columns">
              <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <router-link :to="{name: 'PromoteurList'}" class="button is-text is-fullwidth">Annuler</router-link>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <button :disabled="errors.any()" type="submit" class="button is-primary is-fullwidth">Valider</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="column is-12 is-margin-top is-paddingless is-border-top columns">
        <div class="column is-6">
          <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-6">
          <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                  :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
            <span v-if="!loading">Valider</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapGetters } from 'vuex'

  const emptyPromoteur = {
    name: null,
    flux_enabled: false,
    flux: {
      user: null,
      pwd: null,
      connector: null,
      host: null,
      webhook: null,
      api_key: null,
      dir: null,
      filename: null
    }
  }

  export default {
    name: 'PromoteurForm',
    data () {
      return {
        promoteur: {},
        route: this.$route
      }
    },
    props: {
      source: {
        required: false
      },
      loading: {
        type: Boolean
      }
    },
    computed: {
      ...mapGetters(['isSuperAdmin']),
      canSubmit () {
        return !this.errors.any()
      }
    },
    methods: {
      update (val) {
        this.promoteur.name = val
      },
      submit () {
        if (!this.promoteur.flux || !this.promoteur.flux.connector) {
          delete this.promoteur.flux
        }
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('submit', this.promoteur)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Erreur Le formulaire est invalide.'
            })
          }
        })
      }
    },
    created () {
      if (this.source) {
        this.promoteur = Object.assign({}, emptyPromoteur, this.source)
      } else {
        let flux = {
          user: null,
          pwd: null,
          connector: null,
          host: null,
          webhook: null,
          api_key: null,
          dir: null,
          filename: null
        }
        this.promoteur = Object.assign({}, emptyPromoteur)
        this.promoteur.flux = Object.assign({}, flux)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurForm.vue